export default {
  getSkus: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/skus/getters.js